// extracted by mini-css-extract-plugin
module.exports = {"FoodCard":"_1XxY5J2iH57mSwXONWEuZE"};